export default __webpack_public_path__ + "static/media/close.3f5c9989.svg";